import { useFeatureFlag } from "../lib/FeatureFlags";

const TEACHER_UNIFIED_MESSAGING_INBOX_FEATURE_FLAG =
  "teacher-unified-messaging-inbox";
const TEACHER_UNIFIED_MESSAGING_INBOX_M2_FEATURE_FLAG =
  "teacher-unified-messaging-inbox-m2";

export function useTeacherUnifiedMessaging() {
  return useFeatureFlag(TEACHER_UNIFIED_MESSAGING_INBOX_FEATURE_FLAG);
}

export function useTeacherUnifiedMessagingM2() {
  const isTeacherUnifiedMessagingEnabled = useTeacherUnifiedMessaging();
  const isTeacherUnifiedMessagingM2Enabled = useFeatureFlag(
    TEACHER_UNIFIED_MESSAGING_INBOX_M2_FEATURE_FLAG,
  );

  return isTeacherUnifiedMessagingEnabled && isTeacherUnifiedMessagingM2Enabled;
}
